module.exports = __webpack_public_path__ + "static/media/hrishi2.66e2d22b.png";